import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "alert.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.23985 4.02C9.00485 2.66 10.9619 2.66 11.7259 4.02L17.3059 13.94C18.0559 15.274 17.0929 16.92 15.5639 16.92H4.40285C2.87285 16.92 1.90985 15.274 2.65985 13.94L8.23985 4.02ZM10.9829 13.921C10.9829 14.1862 10.8775 14.4406 10.69 14.6281C10.5024 14.8156 10.2481 14.921 9.98285 14.921C9.71763 14.921 9.46328 14.8156 9.27574 14.6281C9.08821 14.4406 8.98285 14.1862 8.98285 13.921C8.98285 13.6558 9.08821 13.4014 9.27574 13.2139C9.46328 13.0264 9.71763 12.921 9.98285 12.921C10.2481 12.921 10.5024 13.0264 10.69 13.2139C10.8775 13.4014 10.9829 13.6558 10.9829 13.921V13.921ZM9.98285 5.921C9.71763 5.921 9.46328 6.02636 9.27574 6.21389C9.08821 6.40143 8.98285 6.65578 8.98285 6.921V9.921C8.98285 10.1862 9.08821 10.4406 9.27574 10.6281C9.46328 10.8156 9.71763 10.921 9.98285 10.921C10.2481 10.921 10.5024 10.8156 10.69 10.6281C10.8775 10.4406 10.9829 10.1862 10.9829 9.921V6.921C10.9829 6.65578 10.8775 6.40143 10.69 6.21389C10.5024 6.02636 10.2481 5.921 9.98285 5.921Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }